import React from "react";
import { createRoot } from "react-dom/client";

import BlockModule from "./Block";
import HorizontalModule from "./Horizontal";
import { ParkingProvider } from "./context";

// PARKING MODULE
const parkingDom = document.querySelector("#parkingmodule");
if (parkingDom) {
    const parkingType = parkingDom.dataset.style;
    const parkingRoot = createRoot(parkingDom);

    parkingRoot.render(
        <ParkingProvider>
            {parkingType == "block" ? <BlockModule /> : <HorizontalModule />}
        </ParkingProvider>
    );
}
